const disabledDays = [
  '2025-05-29', // Christi Himmelfahrt
  '2025-06-09', // Pfingstmontag
  '2025-10-03', // Tag der deutschen Einheit
  '2025-12-25', // 1. Weihnachtstag
  '2025-12-26', // 2. Weihnachtstag
  '2026-01-01', // Neujahr
  '2026-04-03', // Karfreitag
  '2026-04-06', // Ostermontag
  '2026-05-01', // Tag der Arbeit
  '2026-05-14', // Christi Himmelfahrt
  '2026-05-25', // Pfingstmontag
  '2026-10-03', // Tag der deutschen Einheit
  '2026-12-25', // 1. Weihnachtstag
  '2026-12-26', // 2. Weihnachtstag
  '2027-01-01', // Neujahr
  '2027-03-26', // Karfreitag
  '2027-03-29', // Ostermontag
  '2027-05-01', // Tag der Arbeit
  '2027-05-06', // Christi Himmelfahrt
  '2027-05-17', // Pfingstmontag
  '2027-10-03', // Tag der deutschen Einheit
  '2027-12-25', // 1. Weihnachtstag
  '2027-12-26', // 2. Weihnachtstag
];

export { disabledDays };
